import axios from 'axios';

export const updateNewPassword = async (formData) => {
    return await axios.post(`${window._HOST}admin/users/changePassword`, formData, {withCredentials: true});
}